module.exports = __webpack_public_path__ + "static/media/delete.a77a610b.svg";